import { createFileRoute } from "@tanstack/react-router";
import i18n from "i18next";
import { PartAttributeSearchPage } from "src/components/views/erp/parts/partAttributeSearch/PartAttributeSearchPage.tsx";

export const Route = createFileRoute("/_authenticated/_shell/productManagement/searchPartsByAttributes")({
	staticData: { title: i18n.t("search_parts_by_attributes"), legacyViewKey: "searchPartsByAttributesPage" },
	component: RouteComponent,
});

function RouteComponent() {
	return <PartAttributeSearchPage />;
}
